<script lang="ts" setup>
import { computed } from 'vue';
import { VAlert } from 'vuetify/components/VAlert';

type AppAlertProps = {
    variant?: 'success' | 'error' | 'info';
    text: string;
};
const { variant = 'success', text } = defineProps<AppAlertProps>();

const customClass = computed(() => `app-alert app-alert--${variant}`);
</script>

<template>
    <v-alert
        :class="customClass"
        color="neutral-variant-99"
        align="left"
        height="48"
    >
        <template #text>
            <span class="text-body-medium">
                {{ text }}
            </span>
        </template>
    </v-alert>
</template>

<style lang="scss">
.app-alert {
    --border-color: transparent;

    border-left: 8px solid var(--border-color);
    min-height: 48px;
}

.app-alert--success {
    --border-color: rgb(var(--v-theme-success));
}

.app-alert--info {
    --border-color: rgb(var(--v-theme-info));
}

.app-alert--error {
    --border-color: rgb(var(--v-theme-error));
}
</style>
